export default "__VITE_ASSET__DRInEE1N__"